import SubstanceBar from "../../js/components/substance-bar/SubstanceBar.js";
import BarButton from "../../js/components/substance-bar/BarButton.js";
import ColorPalette from "../../js/components/color-palette/ColorPalette.js";
import ColorPreset from "../../js/entities/color-scheme/ColorPreset.js";
import VisualizationGrid from "../../js/components/visualization/VisualizationGrid.js";
import {BatchPageController} from "../../js/controller/BatchPageController.js";
import SubstanceBarItem from "../../js/components/substance-bar/SubstanceBarItem.js";
import Paginator from "../../js/components/plate/paginator/Paginator.js";
import AliasColorRepository from "../../js/repository/AliasColorRepository.js";
import BatchPageIoC from "../../components/BatchPageIoC.js";
import HtmlUtils from "../../components/HtmlUtils.js";
import HttpClient from "../../js/repository/HttpClient.js";
import BatchPageOperationNotAllowedErrorHandler from "../../js/entities/error/BatchPageOperationNotAllowedErrorHandler.js";
import DialogUtils from "../../components/DialogUtils.js";
import HttpErrorHandler from "../../js/entities/error/HttpErrorHandler.js";
import {disableBFCache} from "../../js/util/CommonUtils.js";
import DropdownList from "../../components/DropdownInput/DropdownList.js";
import DropdownInput from "../../components/DropdownInput/DropdownInput.js";
import {extractOrgNameFromUrl} from "../../js/util/UrlUtils.js";
import Org from "../../js/entities/organization/Org.js";
import IdExtractor from "../../js/util/IdExtractor.js";

window.onload = async () => {
	disableBFCache();
	window.customElements.define('substance-bar', SubstanceBar);
	window.customElements.define('substance-bar-item', SubstanceBarItem);
	window.customElements.define('bar-button', BarButton);
	window.customElements.define('color-palette', ColorPalette);
	window.customElements.define('paginator-cmp', Paginator);
	window.customElements.define('dropdown-list', DropdownList);
	window.customElements.define('dropdown-input', DropdownInput);
	DialogUtils.initMutationObserverToPreventScrollWhenDialogIsOpened();
	const securityContext = await HttpClient.createSecurityContext();
	const ioc = new BatchPageIoC(securityContext);
	const pageHeaderCmp = ioc.getPageHeaderCmp();
	pageHeaderCmp.init(document.querySelector('.page-header'));
	pageHeaderCmp.setSecurityContext(securityContext);
	const errorHandler = ioc.getGlobalErrorHandler();
	errorHandler.init();
	errorHandler.addOperationNotAllowedErrorHandler(new BatchPageOperationNotAllowedErrorHandler(pageHeaderCmp));
	errorHandler.addHttpErrorHandler(new HttpErrorHandler());

	let batchMeta;
	try {
		batchMeta = await ioc.getBatchRepository().getMeta(IdExtractor.extractIdAtUrlEnd());
	} catch (err){
		HtmlUtils.onPageDataAccessExceptionThrown(document.querySelector('.batch-page'), err);
	}
	if (!batchMeta)
		return;
	const substanceBarCmp = ioc.getSubstanceBarCmp();
	substanceBarCmp.init(document.body, {showAddButton: batchMeta.isWritable()});
	const aliasColorRepository = new AliasColorRepository(ioc.getGlobalSettingsRepository());
	const colorScheme = await aliasColorRepository.getGlobalColorScheme();
	colorScheme.setBatchColorPreset(new ColorPreset(batchMeta.aliasColors.asArray()))
	const visGrid = new VisualizationGrid(batchMeta, document.querySelector('.vis-grid'), ioc.getBatchRepository());
	const org = extractOrgNameFromUrl() ? await ioc.getOrganizationRepository().getOrganization(extractOrgNameFromUrl()) : Org.empty()
	const controller = new BatchPageController(colorScheme, visGrid, ioc, securityContext, batchMeta, org);
	await controller.renderPage(batchMeta);

	document.addEventListener('keydown', (evt) => {
		if (!evt.ctrlKey && !evt.metaKey && evt.code === "KeyV") {
			evt.stopPropagation();
			controller.showAddVisualizationDialog()
		}
	})
};